// routes/_app.ranking.($type).($filterType).tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { createHydratingClientLoader, dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.ranking.($type).($filterType)'

const getClientModule = () =>
  import('src/clientRoutes/_app.ranking.($type).($filterType)')

export const handle = { name: 'ranking' }

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export const clientLoader =
  createHydratingClientLoader<Awaited<ReturnType<typeof loader>>>(
    getClientModule,
  )

export default dynamic(getClientModule, { ssr: false })
